module.exports = __webpack_public_path__ + "static/media/zhihu.ed2f5aee.svg";